import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext.jsx";
import { api } from "../api/client.js";
import { useLoading } from "../loading/LoadingContext.jsx";
import PeriodPicker, { useDefaultPeriod } from "../components/PeriodPicker.jsx";

export default function ByAccount() {
  const { idToken } = useAuth();
  const { start, stop } = useLoading();
  const [period, setPeriod] = useState(useDefaultPeriod());
  const [accounts, setAccounts] = useState([]);
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    setErrorMsg(null);
    start();
    api
      .getCostByAccount(idToken, period)
      .then((r) => setAccounts(r.accounts))
      .catch((err) => setErrorMsg(err.message))
      .finally(stop);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idToken, period]);

  return (
    <div>
      <div className="topbar">
        <h2>By Account</h2>
        <PeriodPicker value={period} onChange={setPeriod} />
      </div>
      {errorMsg && <div className="error-banner">{errorMsg}</div>}
      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Account</th>
              <th>Account ID</th>
              <th>Total</th>
              <th>Last updated</th>
            </tr>
          </thead>
          <tbody>
            {accounts.length === 0 && (
              <tr>
                <td colSpan={4} className="empty-row">
                  No data for this period yet.
                </td>
              </tr>
            )}
            {accounts.map((a) => (
              <tr key={a.account_id}>
                <td>{a.account_name}</td>
                <td className="muted mono">{a.account_id}</td>
                <td>
                  {a.currency} {a.total.toLocaleString()}
                </td>
                <td className="muted">{a.last_updated ? new Date(a.last_updated).toLocaleString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
